import type {
  FieldType,
  FormField
} from '@elfsight/widget-form-builder/widget';

export const NAME_ID = 'name';
export const PHONE_ID = 'phone';
export const EMAIL_ID = 'email';
export const NOTES_ID = 'notes';
export const SERVICE_NAME_ID = 'service_name';
export const SERVICE_PRICE_ID = 'service_price';
export const SERVICE_DESCRIPTION_ID = 'service_description';
export const SERVICE_DURATION_ID = 'service_duration';
export const BOOKING_START_DATE_ID = 'booking_start_date';
export const BOOKING_END_DATE_ID = 'booking_end_date';
export const BOOKING_PAGE_ID = 'webpage';
export const BOOKING_DATE_ID = 'booking_date';
export const BOOKING_LOCALIZED_DATETIME_ID = 'booking_localized_datetime';
export const BOOKING_TIMEZONE_ID = 'booking_timezone';
export const OWNER_LANGUAGE_ID = 'owner_language';
export const BUSINESS_NAME_ID = 'business_name';
export const BUSINESS_DESCRIPTION_ID = 'business_description';
export const BUSINESS_LOGO_ID = 'business_logo_url';
export const BUSINESS_CONTACTS_ADDRESS_ID = 'business_contacts_address';
export const BUSINESS_CONTACTS_WEBSITE_ID = 'business_contacts_website';
export const BUSINESS_CONTACTS_PHONE_ID = 'business_contacts_phone';
export const BUSINESS_CONTACTS_EMAIL_ID = 'business_contacts_email';

export const FIELDS: FormField[] = [
  {
    id: NAME_ID,
    label: 'Name',
    name: 'name',
    type: 'shortText' as FieldType,
    required: false,
    visible: true
  },
  {
    id: PHONE_ID,
    label: 'Phone Number',
    type: 'phone' as FieldType,
    name: 'phone',
    required: true,
    visible: true
  },
  {
    id: EMAIL_ID,
    label: 'Email',
    name: 'email',
    type: 'email' as FieldType,
    required: false,
    visible: true
  },
  {
    id: NOTES_ID,
    label: 'Notes',
    name: 'notes',
    type: 'longText' as FieldType,
    required: false,
    visible: true
  }
];

export const BOOKING_HIDDEN_FIELDS: FormField[] = [
  {
    id: 'business_name',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_description',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_logo_url',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_contacts_email',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_contacts_phone',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_contacts_website',
    type: 'hidden' as FieldType
  },
  {
    id: 'business_contacts_address',
    type: 'hidden' as FieldType
  },
  {
    id: SERVICE_NAME_ID,
    type: 'hidden' as FieldType
  },
  {
    id: 'service_description',
    type: 'hidden' as FieldType
  },
  {
    id: 'service_duration',
    type: 'hidden' as FieldType
  },
  {
    id: SERVICE_PRICE_ID,
    type: 'hidden' as FieldType
  },
  {
    id: 'booking_localized_datetime',
    type: 'hidden' as FieldType
  },
  {
    id: BOOKING_START_DATE_ID,
    type: 'hidden' as FieldType
  },
  {
    id: BOOKING_END_DATE_ID,
    type: 'hidden' as FieldType
  },
  {
    id: 'booking_timezone',
    type: 'hidden' as FieldType
  },
  {
    id: BOOKING_PAGE_ID,
    type: 'hidden' as FieldType
  },
  {
    id: 'owner_language',
    type: 'hidden' as FieldType
  }
];
